import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";
import { AUTH_CHECK_LOGIN } from "@/store/action-types";
import { AnalysisRoutes } from "./lab/AnalysisRoutes";
import { AnalyteRoutes } from "./lab/AnalyteRoutes";
import { AttributesListsRoutes } from "./lab/AttributesListsRoutes";
import { CustomerRoutes } from "./crm/CustomerRoutes";
import { InstrumentRoutes } from "./lab/InstrumentRoutes";
import { InstrumentInstanceRoutes } from "./lab/InstrumentInstanceRoutes";
import { InstrumentInstanceScheduleRoutes } from "./lab/InstrumentInstanceScheduleRoutes";
import { InstrumentRunnerRoutes } from "./lab/InstrumentRunnerRoutes";
import { LaboratoryRoutes } from "./lab/LaboratoryRoutes";
import { ManagedListsRoutes } from "./lab/ManagedListsRoutes";
import { PrepProcessRoutes } from "./lab/PrepProcessRoutes";
import { PrepTaskRoutes } from "./lab/PrepTaskRoutes";
import { PrepWorkflowRoutes } from "./lab/PrepWorkflowRoutes";
import { ProcessScheduleRoutes } from "./lab/ProcessScheduleRoutes";
import { ProjectRoutes } from "./lab/ProjectRoutes";
import { QualityControlRoutes } from "./lab/QualityControlRoutes";
import { ResultExportRoutes } from "./lab/ResultExportRoutes";
import { ResultManagerRoutes } from "./lab/ResultManager";
import { ServiceQuestionRoutes } from "./lab/ServiceQuestionRoutes";
import { SampleRoutes } from "./lab/SampleRoutes";
import { SampleTypeRoutes } from "./lab/SampleTypeRoutes";
import { ScheduleRoutes } from "./lab/ScheduleRoutes";
import { StaffRoutes } from "./lab/StaffRoutes";
import { SubmissionRoutes } from "./lab/SubmissionRoutes";
import { TestPackageRoutes } from "./lab/TestPackageRoutes";
import { TestPackageGroupRoutes } from "./lab/TestPackageGroupRoutes";
import { TestProcessRoutes } from "./lab/TestProcessRoutes";
import { TestTaskRoutes } from "./lab/TestTaskRoutes";
import { TestWorkflowRoutes } from "./lab/TestWorkflowRoutes";
import { TurnaroundRoutes } from "./lab/TurnaroundRoutes";
import { WorkGroupRoutes } from "./lab/WorkGroupRoutes";
import { ResultRoutes } from "./modus/ResultRoutes";
import { OrderRoutes } from "./cashier/OrderRoutes";
import { PrepScheduleRoutes } from "./lab/PrepScheduleRoutes";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/pages/misc/Dashboard");

// Views - Pages
const Page404 = () => import("@/pages/misc/Page404");
const ComingSoon = () => import("@/pages/misc/ComingSoon");
const Login = () => import("@/pages/auth/Login");
// const Register = () => import("@/pages/auth/Register");
// const RegisterConfirmation = () => import("@/pages/misc/RegisterConfirmation");
// const RegisterSuccess = () => import("@/pages/misc/RegisterSuccess");
const PasswordReset = () => import("@/pages/auth/PasswordReset");
const PasswordResetChange = () => import("@/pages/auth/PasswordResetChange");
const ReferenceDocuments = () => import("@/pages/misc/ReferenceDocuments");

Vue.use(Router);

const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: "*", component: Page404 },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      meta: { requiresAuth: true },
      children: [].concat(
        [
          { path: "dashboard", name: "Dashboard", component: Dashboard },
          // {
          //   path: "customer-management",
          //   redirect: "/customer",
          //   name: "Customers",
          //   component: {
          //     render(c) {
          //       return c("router-view");
          //     }
          //   }
          // },
          // {path: 'customers', name: 'List Customers', component: /*CustomerDashboard*/CustomerIndex,},
          // {path: 'customers/add', name: 'Add Customer', component: /*CustomerForm*/CustomerAdd},
          // {path: 'customers/recent', name: 'Recent Customers', component: ComingSoon},
          // {path: 'customers/active', name: 'Active Customers', component: ComingSoon},
          // {path: 'customers/newest', name: 'New Customers', component: ComingSoon},
          // {path: 'customers/:id', name: 'View Customer', component: /*CustomerDetail*/ComingSoon},
          // {path: 'customers/:id/edit', name: 'Edit Customer', component: /*CustomerForm*/CustomerEdit},
          {
            path: "schedule-management",
            redirect: "schedule/today",
            name: "Lab Schedule",
            component: {
              render(c) {
                return c("router-view");
              },
            },
          },
          {
            path: "schedule/today",
            name: "Today",
            component: ComingSoon,
          },
          {
            path: "schedule/upcoming",
            name: "Upcoming",
            component: ComingSoon,
          },
          {
            path: "schedule/recent",
            name: "Recent",
            component: ComingSoon,
          },
          {
            path: "lab-management",
            redirect: "lab/settings",
            name: "Lab Management",
            component: {
              render(c) {
                return c("router-view");
              },
            },
          },
          {
            path: "lab/settings",
            name: "Lab Settings",
            component: ComingSoon,
          },
          {
            path: "api-activity",
            name: "API Activity",
            component: ComingSoon,
          },
          {
            path: "lab/current",
            name: "In Progress",
            component: ComingSoon,
          },
          {
            path: "reference-documents",
            name: "Reference Documents",
            component: ReferenceDocuments,
          },
        ],
        AnalysisRoutes.fetchRoutes(),
        AnalyteRoutes.fetchRoutes(),
        AttributesListsRoutes.fetchRoutes(),
        CustomerRoutes.fetchRoutes(),
        InstrumentRoutes.fetchRoutes(),
        InstrumentInstanceRoutes.fetchRoutes(),
        InstrumentInstanceScheduleRoutes.fetchRoutes(),
        InstrumentRunnerRoutes.fetchRoutes(),
        LaboratoryRoutes.fetchRoutes(),
        ManagedListsRoutes.fetchRoutes(),
        PrepProcessRoutes.fetchRoutes(),
        PrepTaskRoutes.fetchRoutes(),
        PrepWorkflowRoutes.fetchRoutes(),
        ProcessScheduleRoutes.fetchRoutes(),
        ProjectRoutes.fetchRoutes(),
        ResultExportRoutes.fetchRoutes(),
        ResultManagerRoutes.fetchRoutes(),
        ScheduleRoutes.fetchRoutes(),
        SubmissionRoutes.fetchRoutes(),
        ServiceQuestionRoutes.fetchRoutes(),
        SampleRoutes.fetchRoutes(),
        SampleTypeRoutes.fetchRoutes(),
        StaffRoutes.fetchRoutes(),
        SubmissionRoutes.fetchRoutes(),
        TestPackageRoutes.fetchRoutes(),
        TestPackageGroupRoutes.fetchRoutes(),
        TestProcessRoutes.fetchRoutes(),
        TestTaskRoutes.fetchRoutes(),
        TestWorkflowRoutes.fetchRoutes(),
        TurnaroundRoutes.fetchRoutes(),
        WorkGroupRoutes.fetchRoutes(),
        ResultRoutes.fetchRoutes(),
        OrderRoutes.fetchRoutes(),
        PrepScheduleRoutes.fetchRoutes(),
        QualityControlRoutes.fetchRoutes()
      ),
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresAuth: false },
    },
    // {
    //   path: "/register",
    //   name: "register",
    //   component: Register,
    //   meta: {requiresAuth: false},
    // },
    // {
    //   path: '/register/confirmation',
    //   name: 'Register Confirmation',
    //   component: RegisterConfirmation,
    //   meta: {requiresAuth: false}
    // },
    // {
    //   path: '/register/success',
    //   name: 'Register Success',
    //   component: RegisterSuccess,
    //   meta: {requiresAuth: false}
    // },
    {
      path: "/password/reset",
      name: "Password Reset",
      component: PasswordReset,
      meta: { requiresAuth: false },
    },
    {
      path: "/password/reset-password",
      name: "Password Reset",
      component: PasswordResetChange,
      meta: { requiresAuth: false },
    },
  ],
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await store.dispatch(AUTH_CHECK_LOGIN).finally(() => {
        next();
      });
    } catch (e) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  document.title = `${to.name ? `${to.name} | ` : ""}DTE`;
  next();
});

export default router;
